import React, { useEffect, useState, useRef } from 'react';
import { customFetch } from '../apiClient';
import Select from "react-select";

const DiscountAuthorityForm = () => {
  const [form, setForm] = useState({ type: "", authority: "" });
  const [loading, setLoading] = useState(false);
  const [loadingList, setLoadingList] = useState(true);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [authorities, setAuthorities] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [touched, setTouched] = useState({});

  const formRef = useRef(null);

  const typeOptions = [
    { value: "Owner", label: "Owner" },
    { value: "Director", label: "Director" },
    { value: "Manager", label: "Manager" },
    { value: "Doctor", label: "Doctor" },
    { value: "Nurse", label: "Nurse" },
    { value: "Employee", label: "Employee" },
    { value: "Admin", label: "Admin" },
    { value: "Other", label: "Other" },
  ];

  useEffect(() => {
    loadAuthorities();
  }, []);

  const loadAuthorities = async () => {
    try {
      setLoadingList(true);
     const res = await customFetch(`/DiscountAuthDt`);
      if (res.ok) setAuthorities(await res.json());
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingList(false);
    }
  };

  const handleTypeChange = (option) => {
    const value = option ? option.value : "";
    setForm(prev => ({ ...prev, type: value }));
    setTouched(prev => ({ ...prev, type: true }));
  };

  const handleEditTypeChange = (option) => {
    const value = option ? option.value : "";
    setEditData(prev => ({ ...prev, type: value }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setTouched(prev => ({ ...prev, [name]: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); 
    setSuccess("");

    if (!form.type || !form.authority.trim()) {
      setError("Please fill Type and Authority Name.");
      setTouched({ type: true, authority: true });
      return;
    }

    setLoading(true);
    try {
     const payload = {
  type: form.type,
  authority: form.authority.trim()
};

        const res = await customFetch(`/DiscountAuthDt`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });
      if (!res.ok) throw new Error(await res.text());

      setSuccess("Authority added successfully!");
      setForm({ type: "", authority: "" });
      setTouched({});
      loadAuthorities();
      
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const cancelEdit = () => {
    setEditId(null);
    setEditData({});
    setError("");
    setSuccess("");
  };

  const handleEditChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const startEdit = (authority) => {
    setEditId(authority.id);
    setEditData({
      type: authority.type || "",
      authority: authority.authority || ""
    });
    setError("");
    setSuccess("");
  };

  const saveEdit = async () => {
    if (!editData.type || !editData.authority.trim()) {
      setError("All fields required");
      return;
    }

    try {
     const hid = Number(sessionStorage.getItem("hospitalId"));

const payload = {
  id: editId,
  hid: hid,
  type: editData.type,
  authority: editData.authority.trim()
};

const res = await customFetch(`/DiscountAuthDt/${editId}`, {
  method: "PUT",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify(payload)
});

      if (!res.ok) throw new Error(await res.text());

      setAuthorities(prev => prev.map(a => 
        a.id === editId ? { ...a, type: payload.type, authority: payload.authority } : a
      ));
      
      setSuccess("Authority updated successfully!");
      cancelEdit();
      
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  const deleteAuthority = async (id) => {
    if (!window.confirm("Are you sure you want to delete this authority?")) return;

    try {
    const hid = Number(sessionStorage.getItem("hospitalId"));

      const res = await customFetch(`/DiscountAuthDt/${id}?hid=${hid}`, {
        method: "DELETE"
      });

      if (!res.ok) throw new Error(await res.text());

      setAuthorities(prev => prev.filter(a => a.id !== id));
      setSuccess("Authority deleted successfully!");
      
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleReset = () => {
    setForm({ type: "", authority: "" });
    setTouched({});
    setError("");
    setSuccess("");
  };

  const filteredAuthorities = authorities.filter(auth =>
    auth.type?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    auth.authority?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '30px', height: '30px', borderRadius: '4px',
      border: state.isFocused ? '1px solid var(--theme-color, #0088cc)' : '1px solid #cbd5e0',
      boxShadow: state.isFocused ? '0 0 0 1px var(--theme-color, #0088cc)' : 'none', 
      '&:hover': { border: '1px solid var(--theme-color, #0088cc)' },
      backgroundColor: 'white', fontSize: '11px'
    }),
    valueContainer: (base) => ({ ...base, padding: '0 8px' }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
    indicatorsContainer: (base) => ({ ...base, height: '30px' }),
    menu: (base) => ({
      ...base, borderRadius: '4px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e0e6ed', zIndex: 9999, fontSize: '11px'
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? 'var(--theme-color, #0088cc)' : state.isFocused ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)' : 'white',
      color: state.isSelected ? 'white' : '#2d3748',
      cursor: 'pointer', padding: '6px 10px',
      '&:active': { backgroundColor: 'var(--theme-color, #0088cc)' },
    }),
  };

  return (
    <div className="discount-authority-container">
      <div className="discount-authority-card">
        {/* Header */}
        <div className="authority-header">
          <div className="header-left">
            <div className="header-icon">
              <i className="bi bi-shield-check"></i>
            </div>
            <div className="header-text">
              <h5>Discount Authority Management</h5>
            </div>
          </div>
          <div className="header-stats">
            <div className="stat-item">
              <i className="bi bi-people-fill"></i>
              <span>{authorities.length} Authorities</span>
            </div>
          </div>
        </div>

        {/* Alerts */}
        {error && (
          <div className="alert-custom alert-danger">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <span>{error}</span>
            <button className="alert-close" onClick={() => setError("")}><i className="bi bi-x"></i></button>
          </div>
        )}
        {success && (
          <div className="alert-custom alert-success">
            <i className="bi bi-check-circle-fill"></i>
            <span>{success}</span>
            <button className="alert-close" onClick={() => setSuccess("")}><i className="bi bi-x"></i></button>
          </div>
        )}

        <div className="authority-body">
          {/* Add Form Section */}
          <div className="form-section">
            <div className="section-header">
              <i className="bi bi-plus-circle"></i>
              <span>Add New Authority</span>
            </div>
            <form ref={formRef} onSubmit={handleSubmit} className="add-form">
              <div className="form-row-inline">
                
                <div className="form-group type-col">
                  <label htmlFor="type"><i className="bi bi-tag"></i> Type <span className="req">*</span></label>
                  <Select
                    id="type" options={typeOptions} value={typeOptions.find(opt => opt.value === form.type)}
                    onChange={handleTypeChange} placeholder="Select Type" styles={customSelectStyles}
                    menuPortalTarget={document.body} menuPosition="fixed" isDisabled={loading}
                  />
                </div>

                <div className="form-group flex-grow">
                  <label htmlFor="authority"><i className="bi bi-person"></i> Authority Name <span className="req">*</span></label>
                  <input
                    id="authority" name="authority" value={form.authority} onChange={handleChange}
                    className={`form-control-custom ${touched.authority && !form.authority.trim() ? 'error' : ''} ${touched.authority && form.authority.trim() ? 'success' : ''}`}
                    placeholder="e.g. Dr. Sharma, Admin" disabled={loading}
                  />
                </div>

                <div className="form-actions-inline">
                  <button type="submit" className="btn-add" disabled={loading}>
                    {loading ? <span className="spinner-border spinner-border-sm"></span> : <i className="bi bi-plus-lg"></i>}
                    {loading ? 'Saving...' : 'Add'}
                  </button>
                  <button type="button" className="btn-reset" onClick={handleReset} disabled={loading}>
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>

          {/* List Section */}
          <div className="list-section">
            <div className="list-header">
              <div className="list-title">
                <i className="bi bi-list-ul"></i>
                <span>Authorities List</span>
              </div>
              <div className="toolbar-actions">
                <div className="search-box">
                  <i className="bi bi-search"></i>
                  <input
                    type="text" placeholder="Search..."
                    value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <button className="btn-refresh" onClick={loadAuthorities} disabled={loadingList}>
                  <i className={`bi bi-arrow-clockwise ${loadingList ? 'spinning' : ''}`}></i>
                </button>
              </div>
            </div>

            <div className="table-container">
              {loadingList ? (
                <div className="loading-state">
                  <div className="spinner"></div>
                  <p>Loading...</p>
                </div>
              ) : filteredAuthorities.length === 0 ? (
                <div className="empty-state">
                  <p>No authorities found</p>
                </div>
              ) : (
                <table className="authorities-table">
                  <thead>
                    <tr>
                      <th className="col-sr">Sr</th>
                      <th className="col-type">Type</th>
                      <th>Authority Name</th>
                      <th className="col-actions">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAuthorities.map((a, index) => (
                      <tr key={a.id} className={editId === a.id ? 'editing' : ''}>
                        <td className="col-sr"><span className="sr-badge">{index + 1}</span></td>
                        
                        {editId === a.id ? (
                          <>
                            <td className="col-type">
                              <Select
                                options={typeOptions} value={typeOptions.find(opt => opt.value === editData.type)}
                                onChange={handleEditTypeChange} styles={customSelectStyles}
                                menuPortalTarget={document.body} menuPosition="fixed"
                              />
                            </td>
                            <td>
                              <input
                                className="form-input-edit" value={editData.authority}
                                onChange={(e) => handleEditChange("authority", e.target.value)}
                                placeholder="Authority name"
                              />
                            </td>
                            <td className="col-actions">
                              <div className="action-buttons">
                                <button className="btn-action btn-save" onClick={saveEdit} disabled={loading} title="Save">
                                  <i className="bi bi-check-lg"></i>
                                </button>
                                <button className="btn-action btn-cancel" onClick={cancelEdit} title="Cancel">
                                  <i className="bi bi-x-lg"></i>
                                </button>
                              </div>
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="col-type">
                              <span className={`type-badge ${a.type?.toLowerCase()}`}>{a.type}</span>
                            </td>
                            <td>
                              <div className="authority-name">
                                <i className="bi bi-person-badge"></i> {a.authority}
                              </div>
                            </td>
                            <td className="col-actions">
                              <div className="action-buttons">
                                <button className="btn-icon btn-edit" onClick={() => startEdit(a)} title="Edit">
                                  <i className="bi bi-pencil"></i>
                                </button>
                                <button className="btn-icon btn-delete" onClick={() => deleteAuthority(a.id)} title="Delete">
                                  <i className="bi bi-trash"></i>
                                </button>
                              </div>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .discount-authority-container { padding: 0; font-family: system-ui, -apple-system, sans-serif; }
        .discount-authority-card {
          background: white; border-radius: 6px; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
          border: 1px solid #e2e8f0; overflow: visible; 
        }

        @keyframes spin { to { transform: rotate(360deg); } }
        .spinning { animation: spin 1s linear infinite; }

        /* Header */
        .authority-header {
          background: var(--theme-color, #0088cc); padding: 8px 12px;
          display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #00d4aa;
        }
        .header-left { display: flex; align-items: center; gap: 8px; }
        .header-icon {
          width: 24px; height: 24px; background: rgba(255, 255, 255, 0.2); border-radius: 4px;
          display: flex; align-items: center; justify-content: center; font-size: 14px; color: white;
        }
        .header-text h5 { margin: 0; color: white; font-size: 14px; font-weight: 600; }
        
        .header-stats { display: flex; gap: 8px; }
        .stat-item {
          background: rgba(255, 255, 255, 0.2); padding: 4px 8px; border-radius: 4px;
          display: flex; align-items: center; gap: 6px; color: white; font-size: 11px; font-weight: 600;
        }

        /* Alerts */
        .alert-custom {
          margin: 8px 12px 0; padding: 6px 10px; border-radius: 4px;
          display: flex; align-items: center; gap: 6px; font-size: 11px; position: relative;
        }
        .alert-danger { background: #fff5f5; color: #e53e3e; border: 1px solid #feb2b2; }
        .alert-success { background: #f0fff4; color: #27ae60; border: 1px solid #9ae6b4; }
        .alert-close { position: absolute; right: 8px; background: none; border: none; cursor: pointer; opacity: 0.6; }

        /* Body */
        .authority-body { padding: 12px; }

        /* Form Section */
        .form-section { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 4px; margin-bottom: 12px; overflow: visible; }
        .section-header {
          background: var(--theme-color, #3182ce); color: white; padding: 6px 10px;
          display: flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 600;
        }
        
        .add-form { padding: 10px; }
        .form-row-inline { display: flex; gap: 10px; align-items: flex-end; }
        
        .form-group { display: flex; flex-direction: column; }
        .type-col { width: 180px; }
        .flex-grow { flex: 1; }
        
        .form-group label { font-size: 11px; font-weight: 600; color: #4a5568; margin-bottom: 4px; display: flex; align-items: center; gap: 4px; }
        .form-group label i { color: var(--theme-color, #3182ce); }
        .req { color: #e53e3e; }

        .form-control-custom {
          width: 100%; padding: 0 8px; border: 1px solid #cbd5e0; border-radius: 4px;
          font-size: 12px; color: #2d3748; outline: none; background: white; height: 30px;
        }
        .form-control-custom:focus { border-color: var(--theme-color, #3182ce); box-shadow: 0 0 0 1px var(--theme-color, #3182ce); }
        .form-control-custom.error { border-color: #e53e3e; }
        .form-control-custom.success { border-color: #38a169; }

        .form-actions-inline { display: flex; gap: 6px; }
        .btn-add, .btn-reset {
          height: 30px; border-radius: 4px; border: none; font-size: 11px; font-weight: 600;
          cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 4px; transition: 0.2s;
        }
        .btn-add { background: var(--theme-color, #3182ce); color: white; padding: 0 12px; }
        .btn-add:hover:not(:disabled) { opacity: 0.9; }
        .btn-add:disabled { opacity: 0.6; cursor: not-allowed; }
        .btn-reset { background: #edf2f7; color: #4a5568; width: 30px; border: 1px solid #cbd5e0; }
        .btn-reset:hover { background: #e2e8f0; }

        /* List Section */
        .list-section { background: white; border: 1px solid #e2e8f0; border-radius: 4px; overflow: hidden; }
        .list-header {
          background: #edf2f7; padding: 8px 10px; display: flex; justify-content: space-between;
          align-items: center; border-bottom: 1px solid #cbd5e0;
        }
        .list-title { display: flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 600; color: #4a5568; }
        
        .toolbar-actions { display: flex; gap: 8px; align-items: center; }
        .search-box { position: relative; width: 200px; }
        .search-box i { position: absolute; left: 8px; top: 50%; transform: translateY(-50%); color: #a0aec0; font-size: 11px; }
        .search-box input {
          width: 100%; padding: 4px 8px 4px 24px; border: 1px solid #cbd5e0; border-radius: 4px; font-size: 11px; outline: none;
        }
        .search-box input:focus { border-color: var(--theme-color, #3182ce); }
        
        .btn-refresh {
          width: 24px; height: 24px; border-radius: 4px; border: 1px solid #cbd5e0;
          background: white; color: #4a5568; cursor: pointer; display: flex; align-items: center; justify-content: center;
        }

        /* Table */
        .table-container { overflow-x: auto; min-height: 150px; }
        .loading-state, .empty-state { text-align: center; padding: 30px 10px; color: #718096; font-size: 11px; }
        .spinner { width: 20px; height: 20px; border: 2px solid #edf2f7; border-top-color: var(--theme-color, #3182ce); border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 8px; }
        
        .authorities-table { width: 100%; border-collapse: collapse; font-size: 11px; text-align: left; }
        .authorities-table thead { background: #f8fafc; }
        .authorities-table th { padding: 6px 10px; font-weight: 600; color: #4a5568; border-bottom: 1px solid #e2e8f0; white-space: nowrap; text-transform: uppercase; }
        .authorities-table td { padding: 6px 10px; border-bottom: 1px solid #edf2f7; color: #2d3748; vertical-align: middle; }
        .authorities-table tbody tr:hover { background: #f7fafc; }
        .authorities-table tbody tr.editing { background: #ebf8ff; box-shadow: inset 0 0 0 1px var(--theme-color, #3182ce); }

        .col-sr { width: 40px; text-align: center; }
        .col-type { width: 120px; }
        .col-actions { width: 70px; text-align: center; }

        .sr-badge { background: var(--theme-color, #3182ce); color: white; padding: 2px 6px; border-radius: 3px; font-weight: 600; font-size: 10px; }
        
        .type-badge { padding: 2px 8px; border-radius: 4px; font-size: 10px; font-weight: 600; display: inline-block; background: #e2e8f0; color: #4a5568; }
        .authority-name { display: flex; align-items: center; gap: 6px; font-weight: 500; }
        .authority-name i { color: var(--theme-color, #3182ce); }

        /* Edit Inputs */
        .form-input-edit {
          width: 100%; padding: 4px 6px; border: 1px solid var(--theme-color, #3182ce); border-radius: 3px; font-size: 11px; outline: none; background: white;
        }

        /* Buttons */
        .action-buttons { display: flex; gap: 4px; justify-content: center; }
        .btn-icon, .btn-action {
          width: 22px; height: 22px; border-radius: 3px; border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center; font-size: 11px; transition: 0.2s;
        }
        .btn-edit { background: #ebf8ff; color: #3182ce; }
        .btn-edit:hover { background: #bee3f8; }
        .btn-delete { background: #fff5f5; color: #e53e3e; }
        .btn-delete:hover { background: #fed7d7; }
        .btn-save { background: #c6f6d5; color: #2f855a; }
        .btn-cancel { background: #edf2f7; color: #4a5568; }

        @media (max-width: 600px) {
          .form-row-inline { flex-direction: column; align-items: stretch; }
          .type-col { width: 100%; }
          .form-actions-inline { width: 100%; }
          .btn-add { flex: 1; }
          .list-header { flex-direction: column; align-items: stretch; gap: 8px; }
          .toolbar-actions { flex-direction: column; }
          .search-box { width: 100%; }
        }
      `}</style>
    </div>
  );
};

export default DiscountAuthorityForm;